import { render, staticRenderFns } from "./VerNotificacion.vue?vue&type=template&id=16dd824a&"
import script from "./VerNotificacion.vue?vue&type=script&lang=js&"
export * from "./VerNotificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports